// SaH budget figures the web works out itself, written once (TAV-3343). Each mirrors the api's shared rule in
// src/libs/tav/sah_budget_figures/, so the care plan overview and the budget page read the same figure as the budget
// list, the Budget Tracker and the Dashboard. The web cannot import the api, so change both together.

/** Allocated / Available, null when there is no Available. Mirrors the api's allocationRateOf (sah_budget_figures/rules.mjs). */
export const allocationRateOf = (allocated: number, available: number): number | null =>
  available > 0 ? allocated / available : null;

/**
 * A budget's Allocated from its priced sections: the lines' totals only, as the budget list and the Budget Tracker
 * read it (allocatedOf). The Grand Total adds the care management fee and care management supplements on top.
 */
export const allocatedOfSections = (sections?: Array<{ totals?: { cost?: number } }>): number =>
  (sections ?? []).reduce((sum, section) => sum + (Number(section.totals?.cost) || 0), 0);
